/*

Flow by WeTheme (http://www.wetheme.com)
Custom JS

*/

/* Mapping from sectionId to Slider instance */
var sliders = {};

var isSafari = navigator.userAgent.indexOf('Safari') > -1;

if (isSafari){
  $('.variants-options').addClass('safari');
}

function bindhCaptcha(){
    //important - manually trigger hcaptcha to bind to forms
    const loginForm = document.getElementById("customer_login");
  
    if (loginForm){
       if (loginForm.getAttribute('data-cptcha') == "false"){
        document.getElementById("customer_login").removeAttribute('data-cptcha');
      }
    }
}

//account sidebar
function toggleAccountDrawer(){
  const drawer = document.getElementById('account-drawer');
  const overlay = document.getElementById('account-drawer-overlay');

  
  if (drawer.classList.contains('open')){
    drawer.classList.remove('open');
    overlay.classList.remove('visible');
  }
  else {
    bindhCaptcha();
    closeMenu();
    drawer.classList.add('open');
    overlay.classList.add('visible');
  }
}



  function closeAccountDrawer() {
    const drawer = document.getElementById('account-drawer');
    const overlay = document.getElementById('account-drawer-overlay');
    drawer.classList.remove('open');
    overlay.classList.remove('visible');
  }

  function openAccountDrawer() {
    bindhCaptcha();
    closeMenu();
    const drawer = document.getElementById('account-drawer');
    const event = new Event("AccountDrawerOpened");
    drawer.dispatchEvent(event);
    const overlay = document.getElementById('account-drawer-overlay');
    drawer.classList.add('open');
    overlay.classList.add('visible');
  }

  
window.addEventListener('DOMContentLoaded', function(){

 const hash = window.location.hash;

  if (hash == "#account"){
    openAccountDrawer();
  }

    $('#close-account-drawer').click((function(){
      closeAccountDrawer();
  }))

  $('#account-drawer-overlay').click((function(){
      closeAccountDrawer();
  }))


  
})



//mobile gestures


function initGesture(elementId, gesture, callbackFn){

  const defaultThreshold = 50;
  const defaultVelocity = 0.3; 
  
  const node = document.getElementById(elementId);
  if (node){
      var element = new Hammer(node, {});
        element.get('swipe').set({ threshold: 50, velocity: 0.3 });
        element.on(gesture, function(e) {
          if (typeof callbackFn === 'function'){
            callbackFn();
          }
      });
  }
}



window.addEventListener('load', function(){
      if (Hammer && window.matchMedia('(max-width: 1024px)').matches){
        initGesture('mobile-menu-drawer', 'swipeleft', ()=>{closeMenu()});
        initGesture('CartDrawer', 'swiperight',()=>{timber.RightDrawer.close();});
        initGesture('searchContainer', 'swipeup',()=>{closeMobileSearchBar()});
        initGesture('ais-facet-container', 'swiperight',()=>{toggleMobileFacets()});
        initGesture('account-drawer', 'swipeleft',()=>{closeAccountDrawer()});
    }
});

//sticky header
window.onscroll = function() {
if (document.body.scrollTop > 45 || document.documentElement.scrollTop > 45) {
    document.getElementById("shopify-section-header").classList.add("sticky_scrolled");
  } else {
    document.getElementById("shopify-section-header").classList.remove("sticky_scrolled");
  }
};

//keyboard accessibility

function skipToContent(){
  const mainContent = document.getElementsByClassName("main-interactive")[0];
  console.log(mainContent);
  if (mainContent){
    mainContent.focus();
    window.scrollTo({
      top: mainContent.y,
      behaviour: 'smooth'
    })
  }
}

function cartSelectorKeypress(e, element, selectFunction) {
if (e.key === 'Enter') {
  event.preventDefault();
  const selector = $(element).find('span');
  $(selector).click()
}
}

function accordionKeypress(e) {
if (e.key === 'Enter') {
  event.preventDefault();
  $(e.target).click()
}
}

function enterTriggersOnClick(e) {
if (e.key === 'Enter') {
  event.preventDefault();
  $(e.target).click()
}
}

function onSearchKeypress(e){
  if (e.key === "Enter"){
    e.preventDefault();
    onSearchOpened();
  }
}

//global sections

function get_section_name(event) {
    var section = null;
    if (event && event.detail) {
        var data = {};
        var dataset = event.target.dataset;
        for (var key in dataset) {
            if (dataset.hasOwnProperty(key) && key.indexOf('themeEditorSection-') === 0) {
                data = JSON.parse(dataset[key]);
            }
        }
        if (data.hasOwnProperty('type')) {
            section = data['type'];
        }
    }
    return section;
}




// Quantity Selector

function load_quantity_selector() {
    var $quantity = $('.nonajax-quantity-selector');
    if ($quantity.length === 0) {
        return;
    }

    var $input = $quantity.find('input');
    $quantity.find('.js-qty__adjust--minus').on('click', function () {
        $input.val(Math.max(1, parseInt($input.val()) - 1));
    });
    $quantity.find('.js-qty__adjust--plus').on('click', function () {
        $input.val(parseInt($input.val()) + 1);
    });
}







var was_mobile = false;
var resize_handler = null;

// Drawers
// Base for all the secondary drawers, primary drawer is the Cart

function Drawer(container_selector, title_selector) {
    this.animation_duration = 300;
    this.$body = $('body');
    this.$drawer = $('#CartDrawer');
    this.$primary_container = $('#CartContainer');
    this.$primary_title = $('#CartTitle');
    this.$secondary_container = $(container_selector);
    this.$secondary_title = $(title_selector);

    this.$primary_group = this.$primary_container.add(this.$primary_title);
    this.$secondary_group = this.$secondary_container.add(this.$secondary_title);
}

Drawer.prototype.show_primary = function () {
    this.$secondary_group.addClass('hide');
    this.$primary_group.removeClass('hide');
};

Drawer.prototype.show_secondary = function () {
    this.$primary_group.addClass('hide');
    this.$secondary_group.removeClass('hide');
};

Drawer.prototype.open = function () {
    this.show_secondary();
    this.$body.one('afterDrawerClose.timber', this.close.bind(this));
    timber.RightDrawer.open();
};

Drawer.prototype.close = function () {
    // Show cart after the animation ends
    setTimeout(function () {
        this.show_primary();
    }.bind(this), this.animation_duration);
};


//Close drawers when clicked on drawer overlay
  $('#DrawerOverlay').off('click').on('click', function (evt) {
      if (timber.LeftDrawer.drawerIsOpen) {
          timber.LeftDrawer.close();
          evt.stopImmediatePropagation();
      }
      if (timber.RightDrawer.drawerIsOpen) {
          timber.RightDrawer.close();
          evt.stopImmediatePropagation();
      }
  });

    // Hide mobile search bar when disabled
    var has_search = $('.search-button').length > 0;
    $('.input-group.search-bar').toggle(has_search);


// Load Quick Shop in the Cart drawer

function ShopNow(url) {
    this.$body = $('body');
    this.drawer = new Drawer('#ShopNowContainer', '#ShopNowTitle');

    this.$body.on('afterAddItem.ajaxCart', this.animate_to_cart.bind(this));

    $.ajax({
        type: 'GET',
        url: url,
        dataType: 'html'
    })
        .done(this.page_loaded.bind(this))
        .error(function (error) {
            // FIXME: handle error correctly
            alert(error);
        });
}

ShopNow.prototype.page_loaded = function (data) {
    var data_dom = $(data);
    var product_single = data_dom.find('.product-single');

    // We don't want to see reviews
    product_single.find('#shopify-product-reviews').remove();
    // We want to see mobile slider instead of desktop version
    product_single.find('.product-single__photos').hide();
    product_single.find('#product-images-mobile').removeClass('large--hide');

    // Replace product html content
    var container = this.drawer.$secondary_container;
    container.find('.product-single').remove();
    container.append(product_single);

    // Replace product JSON
    container.find('#ProductJson-product-template').remove();
    container.append(data_dom.find('#ProductJson-product-template'));

    load_quantity_selector();
    //load_ownCarousel();
    load_option_selectors(container[0]);
    load_tabs();
    load_swatches();

    if (typeof ajaxCart !== "undefined") {
        ajaxCart.init({
            formSelector: '.AddToCartForm',
            cartContainer: '#CartContainer',
            addToCartSelector: '#AddToCart',
            cartCountSelector: '#CartCount',
            moneyFormat: window.Currency ? window.Currency.moneyFormats[window.Currency.shopCurrency].money_format : window.default_currency_format
        });
    }

    this.drawer.open();
};

// Fade in animation between Quick Shop and Cart
ShopNow.prototype.animate_to_cart = function () {
    this.$body.one('afterCartLoad.ajaxCart', function () {
        timber.RightDrawer.close();
        setTimeout(function () {
            this.drawer.show_primary();
            timber.RightDrawer.open();
            this.drawer.$drawer.scrollTop(0);
        }.bind(this), this.drawer.animation_duration);
    }.bind(this));
};



//timer

let timerActive = false;
if (timerActive){

  console.log('Timer script')
  
let endTime = "November 26 2022 11:59:59";

  $('#shopify-section-text-adverts').addClass('timer');
  $('#productpage-text-adverts').addClass('timer');
  

    $('.text-advert-section').html(`<div class="timer-container"><span class="oneline"><span class="topline" style="min-width: 180px;">🔓  30% OFF EVERYTHING &nbsp</span>
  
  <span id="timer-hours" class="sub-timer timer-hours">00</span>
  <span class="separator">:</span>
  <span id="timer-minutes" class="sub-timer timer-minutes">00</span>
  <span class="separator">:</span>
  <span id="timer-seconds" class="sub-timer timer-seconds">00</span>
  </span>
  &nbsp&nbsp
  
  <span class="oneline">USE CODE: &nbsp<span class="timer-code">GIMME30</span> 🔓</span></div>`);

  date = window.countdown(new Date(endTime), function(fs){

    if (fs.start > fs.end) {
    var seconds = fs.seconds;
    if (fs.seconds < 10) {
      seconds = "0" + fs.seconds.toString();
    }

    var minutes = fs.minutes;
    if (fs.minutes < 10) {
      minutes = String("0" + fs.minutes);
    }

    var daysInHours = fs.days * 24;
    var totalHours = fs.hours + daysInHours;

    var hours = totalHours;
    if ((totalHours) > 100) {
      if (window.matchMedia('(max-width: 768px)').matches){
      $('#timer-hours').css('padding-left','12px');
      }
      else {
      $('#timer-hours').css('width','70px');
      $('#timer-hours').css('padding-left','12px');
      }
    }
    if (totalHours < 10) {
      hours = String("0" + totalHours);
    }
    $('.timer-hours').text(hours);
    $('.timer-minutes').text(minutes);
    $('.timer-seconds').text(seconds);
    }
        
  $('.text-advert-section').css('background-color','black');
  $('.text-advert-section').addClass('timer');
  
});
                          
}


//accordion dropdowns

$('.menu_accordion p').on('click', function() {
  if($(this).parent().hasClass('active')){
    $(this).parent().removeClass('active');
    $('.content_accordion').hide();
  } else {
    $('.menu_accordion').removeClass('active');
    $('.content_accordion').hide();
    $(this).parent().find('.content_accordion').show();
    $(this).parent().addClass('active');
  }
});

$('.view-sizes a').on('click', function(e) {
	e.preventDefault();
  	$('.size-chart-accordion p').click();
  	$('html, body').animate({
        scrollTop: $(".view-sizes").offset().top
    }, 500);
});

$('body').on('click', '.radioSelectContainer_main label span', function() {
  	var size = $(this).text();
	$('.view-sizes p span').text(size);
});

$('.quick-shop-quickadd').on('click', function(e) {
  e.preventDefault();
  if ($(this).parent().hasClass("variants-options-on")) {
      $('.grid-view-item').removeClass('variants-options-on');
  } else {
      $('.grid-view-item').removeClass('variants-options-on');
	  $(this).parent().addClass('variants-options-on'); 
  }

});

// open mobile menu by clicking "menu" text
$('.NavDrawerClose').on('click', function(e){
    $('.js-drawer-open-left-link.icon-fallback-text').click();
  	e.preventDefault();
});


// back in stock
$('#back-in-stock').on('click touchstart', function(){
	$('.bis-reset .bis-button').click();
});
$('body').on('click','#AddToCartForm .selector-wrapper label', function(){
	if ( $( this ).hasClass("sold_out") ) {
     	 $('#back-in-stock').addClass('on');
    } else {
     	 $('#back-in-stock').removeClass('on');
    }
});

$('body').on('click', '.add-to-bag-custom', function(){    
    addItemToCart( $(this).attr("attr-id"), 1, "1", "Months");
});

function addItemToCart(variant_id, qty, frequency, unit_type) {
  data = {
    "id": variant_id,
    "quantity": qty
  }

  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function() { 
      ajaxCart.load();
    }
  });
}
  





//get alternate sized images from shopify
function getSizes(src, size){

        if (!src) {
          return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
        }

        if (size === 'medium') {
          return src.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + 'medium' + '.$2');
        }
        
        if (size === 'large') {
          return src.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + '480x' + '.$2');
        }

        if (size === 'desktop') {
          return src.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + '760x' + '.$2');
        }
        
        return src;

};
  
  
//calculate discount for sitewide sale
  function calculateSaleDiscount(price, percent){

    let salePrice = (((price * percent) / 100).toFixed(2));
    return salePrice;
  }


//changes the product view when alternate swatches are selected on collection pages

function changeActiveItem(url, swatch, id) {


    let productDetails;
    
    function populate(e){


    $('#' + id +'_item_title').text(e.title);
    $('#' + id +'_item_title').attr('href',e.url);

      //load new prices

      let priceVaries = false;
      if (e.price_max != e.price_min){
        priceVaries = true;
      }

      let priceString = "";
      const generalPrice = e.variants[0].price;
      if (priceVaries){
        const formattedMin = window.Shopify.formatMoney(e.price_min, `{{amount}}`);
        const formattedMax = window.Shopify.formatMoney(e.price_min, `{{amount}}`);
        priceString = `${window.currencySymbol}${formattedMin} - ${window.currencySymbol}${formattedMax}`;
      }
      else {
      
      const formattedPrice = window.Shopify.formatMoney(generalPrice, `{{amount}}`);
      priceString = `${window.currencySymbol}${formattedPrice}`;
      }



      if (e.available || e.tags?.includes("COMING_SOON")) {
      
      $(".price_" + id).text(priceString);

      if (!priceVaries){


      //if the new item is on sale
      if (e.compare_at_price){

      $('#sale_badge_' + id).css('display','block');
      $('#sale_badge_' + id).html(`<div class="sale-badge">On Sale</div>`);

      let fullPrice = e.compare_at_price;

       var formattedFullPrice = window.formatCurrency(fullPrice);
       formattedFullPrice = window.Shopify.formatMoney(formattedFullPrice, `{{amount}}`);

        $(".price_" + id).append(`<span class="compare_${id} money product-grid--compare-price discount">` + window.currencySymbol + formattedFullPrice + '</span>');

        //replace % off text
        let percentOff = 100 - (Math.round((e.variants[0].price / e.variants[0].compare_at_price ) * 100));
        
        if ($('#grid_percentage_compare_' + id)){
          $('#grid_percentage_compare_' + id).text(`${percentOff}% OFF`);
        }
        else {
          let percentOffHtml = `<span class="grid_percentage_compare">${percentOff}% OFF</span>`;
          $(".price_" + id).append(percentOffHtml);
        }
        

          }
          else {
          $('#sale_badge_' + id).css('display','none');
          $('#grid_percentage_compare_' + id).text("");
          $(".compare_" + id).text("");
          $("#percentage_compare_" + id).text("");

            if (window.sitewideSale ){

              let discountedPrice = calculateSaleDiscount(generalPrice, window.discounted_percentage);
              discountedPrice = Math.floor(discountedPrice);
              discountedPrice = window.Shopify.formatMoney(discountedPrice, `{{amount}}`);

              //$(".price_" + id).append(`<span id="percentage_compare_${id}" class="active-sale-discount money">&ensp;&ensp;${window.currencySymbol}${discountedPrice} with code: ${window.discount_code}</span>`);
            }

            else {
              $('#percentage_compare_' + id).text('');
            }
            
          }

        }


    }
  else {
    $(".price_" + id).text("Sold Out");
    $('#sale_badge_' + id).css('display','none');
  }
  
      //reload gallery

      let galleryHtml = `<div id="tinySlider-contents_${id}" style="padding-top: 150%; height: 0; width: 100%; background-color: #fcfcfc;"><div id="" class="tinySlider-container tinySlider-container_${id}" style="position: absolute; top: 0; left: 0;">`;
      
      let numberImages = 6;
      if (e.images.length < 6) {
        numberImages = e.images.length;
      }
      
      for (let i = 0; i < numberImages; i++){

       // mobile = 670px width and below
      var mobile = getSizes(e.images[i], 'large');
      var mobileLrg = getSizes(e.images[i], 'grande');
      var desktop = getSizes(e.images[i], 'desktop');
      var original = e.images[i];
      
      galleryHtml += `<a href="${url}"><img srcset="${desktop} 760w,
               ${mobileLrg} 480w, ${mobile} 280w" 
               sizes="(max-width: 450px) 280px, (max-width: 768px) 480px, 760px"></a>`;
      }
      
      galleryHtml += `</div></div>`;

      let oldSlider = document.getElementById('tinySlider-contents_'+id);
  
      var prevNode = oldSlider.parentNode.parentNode.querySelector('.tinySlider-prevButton');
      var nextNode = oldSlider.parentNode.parentNode.querySelector('.tinySlider-nextButton');

      
      oldSlider.remove();
      
      $(prevNode).after(galleryHtml);
  
      let newSlider = document.getElementsByClassName('tinySlider-container_' + id)[0];


    sliderObject = tns({
        container: newSlider,
        items: 1,
        touch: true,
        slideBy: 'page',
        autoplay: false,
        preventScrollOnTouch: 'auto',
        swipeAngle: 40,
        prevButton: prevNode,
        nextButton: nextNode,
      });

      $(newSlider).addClass('rendered');

  

    //repopulate the quick size selectors

    let variantContainer = document.getElementById('results-cart-selector_' + id);
    variantContainer.replaceChildren();
    
    for (let i = 0; i<e.variants.length;i++){

      if (e.variants[i].available){

        let title = e.variants[i].title;
                          if (title == 'Default Title'){
                            title = 'OSFA';
            }

        variantContainer.innerHTML += `<form id="AddToCartForm" action="/cart/add" method="post" enctype="multipart/form-data" class="quick-add-to-cart clearfix AddToCartForm">
        <input type="hidden" name="id" value="${e.variants[i].id}" />
        <input data-ph-capture-attribute-product-name="${e.title}" data-ph-capture-attribute-product-price="${e.variants[i].price}" data-ph-capture-attribute-page-type="Collection Page"  type="submit" name="add" id="AddToCart" class="AddToCart" value="${title}" />
        </form>`;
      }
    }

    //attach ajax cart to variant selectors

    window.ajaxCart.init({
            formSelector: '.AddToCartForm',
            cartContainer: '#CartContainer',
            addToCartSelector: '#AddToCart',
            cartCountSelector: '#CartCount',
            moneyFormat: window.Currency ? window.Currency.moneyFormats[window.Currency.shopCurrency].money_format : window.default_currency_format
    });


      //repopulate and initialise swym wishlist on collection grid items

      var wishlistDiv = $('#wishlist_' + id);
      wishlistDiv.empty();
      
      wishlistDiv.append(`<button data-with-epi="true" class="swym-button swym-add-to-wishlist-view-product product_${e.id} swym-iconbtnlink swym-heart swym-loaded" data-swaction="addToWishlist" data-product-id="${e.id}" data-variant-id="${e.variants[0].id}" data-product-url="${window.theme?.shopUrl}${url}" aria-label="Add to Wishlist"></button>`);
                          
                          
      var wishlist_button = $('.swym-add-to-wishlist-view-product.product_'+id).attr('data-product-id',e.id);
      wishlist_button.attr('data-variant-id',e.variants[0].id);
      wishlist_button.attr('data-product-url',window.theme?.shopUrl + e.url);

      
      window.SwymCallbacks.push(swymCallbackFn);

        function swymCallbackFn(swat) {
          swat.initializeActionButtons('#wishlist_' + id);
        }
    }



    // get product info for swatch

    let retry = 0;
  
    function getSwatchProduct(url, retry){

      let reqUrl = `${url}.js`;

      if (retry !== 0){
        reqUrl = `${url}-${retry}.js`;
      }
      
      jQuery.ajax({
        type: 'GET',
        url: reqUrl,
        dataType: 'json',
        success: function(e) {

        $('.' + id + '_swatch').removeClass("selected");
        $('#' + id + '_' + swatch).addClass("selected");
    
        productDetails = e;
        populate(e);
    
        },
        error: function(e){
          
          //if the product request fails, try with duplicate handles (e.g product-1, product-2)
          if (retry < 4){
            retry += 1;
            getSwatchProduct(url, retry)
          }
          else {
            console.log('Product not found');
            $('.' + id + '_swatch').removeClass("selected");
            $('.' + id + '_swatch').css("display","none");
            $('#' + id + '_' + swatch).css("display","none");
          }
        }
    });
    }

    getSwatchProduct(url, retry);
    
    $('.' + id + '_swatch').removeClass("selected");
    $('#' + id + '_' + swatch).addClass("selected");  

}
